module.exports = __webpack_public_path__ + "static/poenicke-d94679189a49946965bf98af03e59e01.png";